// Centrale contentinstellingen voor DT Timmerwerken.
// Pas hier contactgegevens, teksten, afbeeldingen en projecten op één plek aan.

export const site = {
  name: "DT Timmerwerken",
  tagline: "Sterk in hout. Strak in afwerking.",
  phoneDisplay: "06 - 21 35 97 59",
  phoneHref: "tel:+31621359759",
  whatsappHref:
    "https://wa.me/31621359759?text=" +
    encodeURIComponent("Hoi! Ik heb een vraag over een klus. Ik stuur een foto mee."),
  email: "info@dt-timmerwerken.nl",
  location: "Opmeer, Noord-Holland",
  address: "",
  kvk: "",
  btw: "",
  workArea: "Opmeer en omgeving",
  heroLabel: "DT TIMMERWERKEN · OPMEER",
  heroTitle1: "Sterk in hout.",
  heroTitle2: "Strak in afwerking.",
  heroRibbon: "Eén vakman. Eén aanspreekpunt.",
  heroSubtext:
    "Van timmerwerk, kozijnen en veranda's tot gevels, glas en onderhoud. DT Timmerwerken uit Opmeer helpt je met vakkundig werk, duidelijke afspraken en persoonlijk contact.",
};

// Teksten per pagina (bewerkbaar via het admin-paneel).
export const pages = {
  home: {
    introEyebrow: "Zelfstandig timmerbedrijf",
    introTitle: "Een vertrouwd gezicht. Van eerste contact tot afwerking.",
    introText:
      "Bij DT Timmerwerken heb je direct contact met de vakman die het werk ook echt uitvoert. Geen tussenpersonen en geen onduidelijke afspraken: ik kom kijken, meet in, maak een heldere offerte en lever het werk af zoals we het hebben besproken.",
    aboutTitle1: "DT Timmerwerken uit Opmeer",
    aboutText1:
      "DT Timmerwerken is een zelfstandig timmerbedrijf uit Opmeer, Noord-Holland. Ik ben 23 jaar en heb meerdere jaren in loondienst in de bouw gewerkt voordat ik voor mezelf begon. Die ervaring neem ik mee in ieder project: van timmerwerk en kozijnen tot gevels, glas en onderhoud.",
    aboutTitle2: "Persoonlijk en vakkundig",
    aboutText2:
      "Je hebt rechtstreeks contact met degene die het werk uitvoert. Dat betekent korte lijnen, duidelijke afspraken en één aanspreekpunt van begin tot eind. Ik werk in Opmeer en omgeving en sta voor netjes, precies werk.",
    ctaTitle: "Een project of onderhoud gepland?",
    ctaText: "Vertel kort over je klus of project. Ik neem zo snel mogelijk contact met je op.",
  },
  overMij: {
    title: "Vakmanschap uit Opmeer",
    intro: "Eén vakman, één aanspreekpunt, één standaard: werk dat klopt tot in de millimeter.",
    heading: "De vakman achter DT",
    text1:
      "Ik ben 23 jaar en werk vanuit Opmeer, Noord-Holland. Na meerdere jaren in loondienst in de bouw heb ik de stap gezet om voor mezelf te beginnen. DT Timmerwerken is het resultaat: een eenmanszaak waarin vakmanschap, precisie en persoonlijk contact centraal staan.",
    text2:
      "Bij mij weet je wie er voor de deur staat. Ik meet in, ik adviseer, ik timmer en ik lever op. Die ene lijn maakt de communicatie kort en de afspraken helder, voor jou én voor mij.",
    facts: [
      { label: "Werkgebied", value: "Opmeer en omgeving" },
      { label: "Specialisme", value: "Timmerwerken, kozijnen, veranda's, dakkapellen, gevels, glas en onderhoud" },
      { label: "Aanpak", value: "Persoonlijk contact, heldere offerte, netjes opgeleverd" },
    ],
    stepsTitle: "Hoe ik werk",
    steps: [
      { title: "Kijken en luisteren", text: "Elk project begint bij jouw verhaal. Ik kom kijken, stel vragen en denk mee over de beste aanpak voor jouw situatie." },
      { title: "Heldere offerte", text: "Je krijgt vooraf een duidelijke offerte met een eerlijke prijs en een realistische planning. Zo weet je waar je aan toe bent." },
      { title: "Netjes uitgevoerd", text: "Ik werk zorgvuldig, houd de werkplek netjes en lever op zoals afgesproken. Pas als jij tevreden bent, is het werk af." },
    ],
  },
  portfolio: {
    title: "Projecten",
    intro:
      "Een greep uit mijn werk in Opmeer en omgeving: van dakkapellen en aanbouwen tot kozijnen, dakramen en houtskeletbouw. Alles zelf gemaakt, gesteld en afgewerkt.",
  },
  contact: {
    title: "Vraag een offerte aan",
    intro:
      "Vertel over je project: wat wil je laten maken, herstellen of vervangen? Voeg gerust een paar foto's toe van de huidige situatie. Ik neem zo snel mogelijk contact met je op om het te bespreken.",
  },
};

// Werkgebied: middelpunt Opmeer, straal in km en plaatsen op de kaart.
export const workArea = {
  center: [52.706, 4.945],
  zoom: 10,
  radiusKm: 25,
  places: [
    { name: "Opmeer", coords: [52.706, 4.945], home: true },
    { name: "Spanbroek", coords: [52.699, 4.952] },
    { name: "Hoogwoud", coords: [52.72, 4.93] },
    { name: "De Weere", coords: [52.735, 4.9] },
    { name: "Aartswoud", coords: [52.745, 4.925] },
    { name: "Obdam", coords: [52.676, 4.906] },
    { name: "Wognum", coords: [52.672, 5.02] },
    { name: "Hoorn", coords: [52.642, 5.059] },
    { name: "Medemblik", coords: [52.771, 5.105] },
    { name: "Wervershoof", coords: [52.728, 5.16] },
    { name: "Enkhuizen", coords: [52.703, 5.29] },
    { name: "Schagen", coords: [52.787, 4.8] },
    { name: "Heerhugowaard", coords: [52.67, 4.84] },
    { name: "Alkmaar", coords: [52.632, 4.749] },
    { name: "Langedijk", coords: [52.69, 4.8] },
  ],
};

// Eigen foto's staan in /public/fotos. Vervang of voeg toe door een bestand
// in die map te zetten en hier het pad aan te passen.
export const images = {
  hero: {
    src: "/fotos/eigenaar-aan-het-werk.jpg",
    alt: "DT Timmerwerken aan het werk bij een kozijn",
  },
  portrait: {
    src: "/fotos/eigenaar-aan-het-werk.jpg",
    alt: "De vakman achter DT Timmerwerken aan het werk",
  },
  timmerwerken: {
    src: "/fotos/houtskeletbouw-wand.jpg",
    alt: "Houtskeletbouwwand met OSB-beplating in de werkplaats",
  },
  verandas: {
    src: "/fotos/veranda.jpg",
    alt: "Houten veranda met plat dak, eiken staanders en glazen schuifwand aan een woning",
  },
  kozijnen: {
    src: "/fotos/uitbouw-kozijnen.jpg",
    alt: "Nieuwe kozijnen en deuren geplaatst in een uitbouw",
  },
  gevels: {
    src: "/fotos/aanbouw-gevelbekleding.jpg",
    alt: "Aanbouw met houten gevelbekleding en nieuw kozijn",
  },
  glas: {
    src: "/fotos/dakraam-binnen.jpg",
    alt: "Nieuw dakraam van binnenuit gezien tijdens de afbouw",
  },
  onderhoud: {
    src: "/fotos/erker-constructie.jpg",
    alt: "Vernieuwing van een erker aan een bestaande woning",
  },
  dakkapel: {
    src: "/fotos/dakkapel-dak.jpg",
    alt: "Dakkapel in aanbouw op een hellend dak",
  },
  dakkapelZijwang: {
    src: "/fotos/dakkapel-zijwang.jpg",
    alt: "Zijwang van een dakkapel met isolatie en regelwerk",
  },
  houtskeletbouw: {
    src: "/fotos/houtskeletbouw-wand.jpg",
    alt: "Houtskeletbouwwand met OSB-beplating in de werkplaats",
  },
  wandBinnen: {
    src: "/fotos/wandconstructie-binnen.jpg",
    alt: "Nieuwe binnenwand met raamopening en leidingwerk",
  },
  kozijnAfgewerkt: {
    src: "/fotos/kozijn-afgewerkt.jpg",
    alt: "Strak afgewerkt raamkozijn aan de binnenzijde",
  },
};

export const services = [
  {
    slug: "timmerwerken",
    title: "Timmerwerken",
    short:
      "Maatwerk timmerwerk voor binnen en buiten: van maatwerkkasten en constructies tot overkappingen en schuttingen.",
    image: images.timmerwerken,
    intro:
      "Timmerwerk is het hart van mijn vak. Of het nu gaat om een kast die naadloos in een schuine wand past, een stevige houtconstructie of een overkapping voor in de tuin: ik werk alles zelf uit, van inmeten tot de laatste schroef.",
    points: [
      "Maatwerk kasten en interieurbetimmering",
      "Houtconstructies en kapwerk",
      "Overkappingen, schuttingen en buitenwerk",
      "Inmeten, maken en monteren door één vakman",
    ],
    sections: [
      {
        heading: "Op maat gemaakt, niet uit de fabriek",
        text: "Elke ruimte is anders. Daarom meet ik alles zelf in en maak ik het werk passend voor jouw situatie. Geen standaardmaten die net niet kloppen, maar houtwerk dat hoort waar het hangt of staat.",
      },
      {
        heading: "Eén aanspreekpunt, van schets tot montage",
        text: "Omdat ik het hele traject zelf doe, blijft de lijn kort. Jij vertelt wat je zoekt, ik denk mee over de uitvoering en lever het werk af zoals we het hebben besproken.",
      },
    ],
  },
  {
    slug: "kozijnen",
    title: "Kozijnen",
    short:
      "Houten kozijnen en deuren op maat, passend bij de stijl van je woning en netjes geplaatst.",
    image: images.kozijnen,
    intro:
      "Een goed kozijn bepaalt de uitstraling van je huis én het comfort erbinnen. Ik maak en plaats houten kozijnen op maat, passend bij de stijl van de woning: van karakteristieke profielen tot strakke, moderne lijnen.",
    points: [
      "Maatwerk houten kozijnen",
      "Voordeuren en achterdeuren",
      "Tochtwerende aansluitingen en dorpels",
      "Combinatie met HR++ glas mogelijk",
    ],
    sections: [
      {
        heading: "Passend bij het karakter van je huis",
        text: "Een jaren-'30-woning vraagt om andere profielen dan een nieuwbouwhuis. Ik kijk naar wat er nu zit en naar wat jij mooi vindt, en maak kozijnen die daarbij passen.",
      },
      {
        heading: "Strak geplaatst, netjes afgewerkt",
        text: "Het plaatsen is minstens zo belangrijk als het maken. Ik zorg voor een strakke aansluiting, goede afwatering en een nette afwerking aan binnen- en buitenkant.",
      },
    ],
    faq: [
      {
        q: "Wat kost een nieuw houten kozijn?",
        a: "Dat hangt af van de afmeting, het profiel, het glas en of er een deur in zit. Ik kom vrijblijvend inmeten en maak een heldere offerte met een vaste prijs, zodat je vooraf precies weet waar je aan toe bent.",
      },
      {
        q: "Kan ik mijn kozijnen laten repareren in plaats van vervangen?",
        a: "Vaak wel. Als alleen de onderdorpel of een stijl is aangetast, kan ik het slechte hout vervangen en het kozijn weer jaren mee laten gaan. Is het kozijn op meerdere plekken slecht, dan is vervangen meestal verstandiger. Ik adviseer eerlijk wat het beste is.",
      },
      {
        q: "Hoe lang duurt het vervangen van een kozijn?",
        a: "Een enkel kozijn vervang ik meestal in één dag, inclusief afwerking. Bij meerdere kozijnen plan ik het werk zo dat de woning elke avond weer wind- en waterdicht is.",
      },
      {
        q: "Kies ik voor hout of kunststof kozijnen?",
        a: "Houten kozijnen passen bij vrijwel elke woning, zijn goed te repareren en gaan met normaal onderhoud tientallen jaren mee. Ik werk uitsluitend met hout en denk graag met je mee over de houtsoort en het profiel dat bij je huis past.",
      },
    ],
  },
  {
    slug: "gevels",
    title: "Gevels",
    short:
      "Houten gevelbekleding die je woning beschermt en een eigen, warm karakter geeft.",
    image: images.gevels,
    intro:
      "Met houten gevelbekleding geef je een woning een eigen gezicht en bescherm je tegelijk de constructie erachter. Ik denk mee over houtsoort, profiel en detaillering, en werk de gevel strak af tot in de hoeken.",
    points: [
      "Open en gesloten gevelbekleding",
      "Duurzame houtsoorten, passend bij jouw wens",
      "Ventilerende achterconstructie",
      "Strakke details rond hoeken, ramen en aansluitingen",
    ],
    sections: [
      {
        heading: "Bescherming en uitstraling in één",
        text: "Een houten gevel is meer dan een buitenlaag. Achter de bekleding zorgt een ventilerende constructie ervoor dat vocht weg kan en de gevel lang mooi blijft.",
      },
      {
        heading: "Het detail maakt het verschil",
        text: "Hoeken, aansluitingen op kozijnen en de overgang naar het dak: juist daar zie je of een gevel met zorg is gemaakt. Daar leg ik de lat hoog, letterlijk en figuurlijk.",
      },
    ],
    faq: [
      {
        q: "Welke houtsoort is geschikt voor gevelbekleding?",
        a: "Veelgebruikte keuzes zijn thermisch gemodificeerd hout, Western Red Cedar, lariks/douglas en Accoya. Elke soort heeft een eigen uitstraling, prijs en onderhoudsbehoefte. Ik laat je samples zien en adviseer wat past bij je woning en budget.",
      },
      {
        q: "Hoeveel onderhoud heeft een houten gevel nodig?",
        a: "Dat hangt af van de houtsoort en of je de gevel laat vergrijzen of in kleur houdt. Onbehandeld hout vergrijst natuurlijk en vraagt nauwelijks onderhoud; een gebeitste of geschilderde gevel heeft om de paar jaar een opfrisbeurt nodig.",
      },
      {
        q: "Kan ik mijn bestaande gevel laten bekleden met hout?",
        a: "Ja, in de meeste gevallen kan houten gevelbekleding over een bestaande steen- of houten gevel heen. Ik breng dan eerst een regelwerk en eventueel isolatie en folie aan, zodat de gevel kan ventileren en je woning direct beter geïsoleerd is.",
      },
      {
        q: "Hoe lang gaat houten gevelbekleding mee?",
        a: "Met een goede ventilerende achterconstructie, juiste bevestiging en passende houtsoort gaat een houten gevel gemakkelijk 30 tot 50 jaar mee. De details bij hoeken, kozijnen en de onderkant bepalen grotendeels de levensduur, en daar besteed ik extra aandacht aan.",
      },
    ],
  },
  {
    slug: "glas",
    title: "Glas",
    short:
      "Glaszetten en isolatieglas, vakkundig geplaatst in nieuwe en bestaande kozijnen.",
    image: images.glas,
    intro:
      "Enkel glas vervangen door HR++ isolatieglas maakt een woning stiller en energiezuiniger. Ik zet glas in zowel nieuwe als bestaande kozijnen, met een strak resultaat en nette afwerking.",
    points: [
      "HR++ isolatieglas",
      "Glas in bestaande houten kozijnen",
      "Herstel na glasschade",
      "Nette beglazing en afwerking",
    ],
    sections: [
      {
        heading: "Comfortabeler wonen",
        text: "Met isolatieglas houd je de warmte beter binnen en het geluid buiten. Vaak kan dat in je bestaande kozijnen, zodat het karakter van de woning behouden blijft.",
      },
      {
        heading: "Zorgvuldig werk aan kwetsbaar materiaal",
        text: "Glaszetten is precisiewerk. Ik meet nauwkeurig in, werk rustig en lever alles schoon en netjes op, zodat je er direct van kunt genieten.",
      },
    ],
  },
  {
    slug: "onderhoud",
    title: "Onderhoud",
    short:
      "Onderhoud en herstel van houtwerk: van houtrotreparatie tot preventief onderhoud aan kozijnen en gevels.",
    image: images.onderhoud,
    intro:
      "Hout gaat lang mee als je er goed voor zorgt. Ik herstel houtrot, vervang aangetaste delen en voer preventief onderhoud uit, zodat kozijnen, deuren en gevels hun werk blijven doen.",
    points: [
      "Houtrotherstel en deelvervanging",
      "Preventief onderhoud aan kozijnen en deuren",
      "Herstel van geveldelen en boeidelen",
      "Advies over onderhoudsmomenten",
    ],
    sections: [
      {
        heading: "Klein herstel voorkomt grote kosten",
        text: "Een aangetast deel van een kozijn hoeft niet te betekenen dat alles vervangen moet worden. Vaak is gericht herstel mogelijk: het slechte hout eruit, nieuw hout erin, strak afgewerkt.",
      },
      {
        heading: "Eerlijk advies over wat nodig is",
        text: "Ik kijk eerst goed wat er aan de hand is en vertel je eerlijk wat nodig is en wat nog jaren kan wachten. Zo houd je grip op je woning en je budget.",
      },
    ],
  },
  {
    slug: "verandas",
    title: "Veranda's",
    short:
      "Houten veranda's en overkappingen op maat: meer buitenleven, strak gebouwd en passend bij je woning en tuin.",
    image: images.verandas,
    intro:
      "Een veranda maakt van je tuin een extra kamer. Droog zitten als het regent, schaduw op een hete dag en 's avonds langer buiten. Ik ontwerp en bouw houten veranda's en overkappingen volledig op maat, afgestemd op je woning, je tuin en hoe jij buiten wilt leven.",
    points: [
      "Vrijstaande en aangebouwde veranda's",
      "Overkappingen voor terras en tuin",
      "Keuze uit polycarbonaat, glas of dicht dak",
      "Fundering, draagconstructie en afwerking in eigen hand",
      "Optioneel: zijwanden, schuifpui, verlichting en vlonder",
    ],
    sections: [
      {
        heading: "Op maat, dus passend bij je huis",
        text: "Geen bouwpakket met standaardmaten, maar een veranda die aansluit op de gevel, de dakrand en de lijnen van je woning. Ik meet ter plekke in en denk mee over hoogte, diepte en de lichtinval in huis.",
      },
      {
        heading: "Gebouwd om jaren mee te gaan",
        text: "Ik werk met duurzame houtsoorten en een stevige fundering. De constructie wordt netjes verankerd en de aansluiting op de woning is waterdicht, zodat je er zonder zorgen jaren plezier van hebt.",
      },
    ],
    faq: [
      {
        q: "Heb ik een vergunning nodig voor een veranda?",
        a: "Vaak niet: een overkapping in de achtertuin is in veel gevallen vergunningvrij, afhankelijk van de afmetingen en de plek op het perceel. Ik kijk dit vooraf samen met je na.",
      },
      {
        q: "Hoe lang duurt het bouwen van een veranda?",
        a: "Een standaard veranda staat meestal binnen enkele dagen. Bij een grotere overkapping met zijwanden, glas of een vlonder rekenen we iets meer tijd. In de offerte geef ik een realistische planning.",
      },
      {
        q: "Welk dak kan ik kiezen?",
        a: "Polycarbonaat (licht en betaalbaar), glas (luxe en helder) of een dicht dak met bijvoorbeeld EPDM en een lichtstraat. Ik adviseer wat het beste past bij je tuin en de ligging op de zon.",
      },
    ],
  },
  {
    slug: "dakkapellen",
    title: "Dakkapellen",
    short:
      "Houten dakkapellen op maat: meer ruimte en licht op zolder, vakkundig geplaatst en netjes afgewerkt.",
    image: images.dakkapel,
    intro:
      "Een dakkapel maakt van een krappe zolder een volwaardige kamer. Ik bouw dakkapellen op maat in hout: van de draagconstructie en isolatie tot de kozijnen, het dak en de afwerking aan binnen- en buitenzijde. Alles in eigen hand, zodat het resultaat precies past bij je woning.",
    points: [
      "Dakkapellen op maat, voor- en achterzijde",
      "Draagconstructie, isolatie en waterdichte aansluiting",
      "Houten kozijnen met HR++ glas en draai-kiepramen",
      "Afwerking met houten, kunststof of zinken zijwangen",
      "Binnenafwerking: aftimmeren, plaatmateriaal en vensterbank",
    ],
    sections: [
      {
        heading: "Van open dak tot afgewerkte kamer",
        text: "Ik maak het dak open, stel de constructie en zorg dat alles dezelfde dag weer wind- en waterdicht is. Daarna volgen de isolatie, de kozijnen, de dakbedekking en de afwerking. Jij hebt één aanspreekpunt voor het hele traject.",
      },
      {
        heading: "Passend bij je woning",
        text: "Een dakkapel moet eruitzien alsof hij er altijd al heeft gezeten. Ik stem de maatvoering, de kozijnindeling en de afwerking af op de stijl van je huis en de buren, zodat het geheel rustig en vanzelfsprekend oogt.",
      },
    ],
    faq: [
      {
        q: "Heb ik een vergunning nodig voor een dakkapel?",
        a: "Aan de achterzijde is een dakkapel vaak vergunningvrij als hij aan de landelijke regels voldoet (onder meer afstanden tot de dakrand en nok en een maximale hoogte). Aan de voorkant of bij een beschermd dorpsgezicht is meestal wel een vergunning nodig. Ik check dit vooraf samen met je.",
      },
      {
        q: "Hoe lang duurt het plaatsen van een dakkapel?",
        a: "De dakkapel zelf staat meestal in één tot twee dagen wind- en waterdicht. Daarna volgen de afwerking buiten en binnen; reken in totaal op ongeveer één tot twee weken, afhankelijk van de grootte en de gekozen afwerking.",
      },
      {
        q: "Wat kost een dakkapel?",
        a: "De prijs hangt af van de breedte, het aantal ramen, de isolatiewaarde en de afwerking van de zijwangen en de binnenkant. Na een vrijblijvend bezoek krijg je van mij een duidelijke offerte met een vaste prijs.",
      },
      {
        q: "Kan een dakkapel ook op een schuin of oud dak?",
        a: "Ja, in de meeste gevallen wel. Ik beoordeel vooraf de kapconstructie en de dakhelling en pas de constructie daarop aan. Bij een oud dak kan dat een mooi moment zijn om direct ook te isoleren.",
      },
    ],
  },
];

export const projects = [
  {
    slug: "dakkapel-plaatsen",
    title: "Dakkapel plaatsen",
    category: "Dakkapellen",
    location: "Opmeer en omgeving",
    image: images.dakkapel,
    gallery: [images.dakkapelZijwang],
    summary:
      "Nieuwe dakkapel op een hellend dak: constructie, isolatie en zijwangen in eigen beheer opgebouwd en strak afgewerkt.",
    body: [
      "Een dakkapel geeft direct meer ruimte en licht op zolder. Voor dit project heb ik de dakkapel vanaf de constructie opgebouwd: het dak opengemaakt, de draagconstructie gesteld en de kapel waterdicht gemaakt.",
      "De zijwangen zijn geïsoleerd en voorzien van regelwerk voor de afwerking. Daarna zijn de kozijnen geplaatst en is alles netjes aangesloten op het bestaande dak, zodat de dakkapel er van buiten uitziet alsof hij er altijd al heeft gezeten.",
    ],
    work: ["Draagconstructie", "Isolatie zijwangen", "Kozijnen plaatsen", "Waterdichte aansluiting op het dak"],
  },
  {
    slug: "aanbouw-met-houten-gevelbekleding",
    title: "Aanbouw met houten gevelbekleding",
    category: "Gevels",
    location: "Opmeer en omgeving",
    image: images.gevels,
    gallery: [images.kozijnen],
    summary:
      "Aanbouw aan een bestaande woning met geïsoleerde gevels, nieuwe kozijnen en deuren en een strakke houten gevelbekleding.",
    body: [
      "Bij deze woning is de aanbouw aan de achterzijde volledig nieuw opgetrokken. De wanden zijn geïsoleerd en voorzien van een dampopen folie, waarna de nieuwe kozijnen en tuindeuren zijn gesteld.",
      "De buitenkant is afgewerkt met houten gevelbekleding, strak aangesloten op de kozijnen en de bestaande gevel. Het resultaat: een lichte, ruime aanbouw die één geheel vormt met het huis.",
    ],
    work: ["Gevelopbouw en isolatie", "Kozijnen en tuindeuren", "Houten gevelbekleding", "Aansluiting op bestaande gevel"],
  },
  {
    slug: "erker-vernieuwen",
    title: "Erker vernieuwen",
    category: "Kozijnen",
    location: "Opmeer en omgeving",
    image: images.onderhoud,
    summary:
      "De bestaande erker aan de voorzijde van de woning is vervangen door een nieuwe houten constructie met kozijnen op maat.",
    body: [
      "De oude erker was aan vervanging toe. In plaats van alleen de kozijnen te vervangen, is de hele erker opnieuw opgebouwd: fundering en vloerconstructie, stijlen en de nieuwe kozijnen op maat.",
      "Omdat alles op elkaar is afgestemd, sluiten de kozijnen strak aan en kan de erker weer jaren mee. De verdere afwerking van gevel en dak is daarna netjes uitgevoerd.",
    ],
    work: ["Vloer- en draagconstructie", "Maatwerk kozijnen", "Stellen en afwerken", "Aansluiting op bestaande gevel"],
  },
  {
    slug: "houtskeletbouw-wanden",
    title: "Houtskeletbouw wanden",
    category: "Timmerwerken",
    location: "Opmeer en omgeving",
    image: images.houtskeletbouw,
    gallery: [images.timmerwerken],
    summary:
      "Houtskeletbouwwanden en houten constructies, geprefabriceerd en op locatie gesteld.",
    body: [
      "Houtskeletbouw is snel, licht en goed te isoleren. Voor dit project heb ik de wanden opgebouwd uit een regelwerk met OSB-beplating, zodat ze als één geheel gesteld kunnen worden.",
      "Ook grotere houten constructies maak ik vooraf zo veel mogelijk klaar, zodat het stellen op locatie vlot verloopt en alles precies past.",
    ],
    work: ["Regelwerk en beplating", "Prefabricage", "Stellen op locatie", "Maatvoering"],
  },
  {
    slug: "dakraam-plaatsen-en-afwerken",
    title: "Dakraam plaatsen en afwerken",
    category: "Glas",
    location: "Opmeer en omgeving",
    image: images.glas,
    gallery: [images.kozijnAfgewerkt],
    summary:
      "Nieuw dakraam geplaatst in een bestaand dak, inclusief isolatie rondom en een strakke binnenafwerking.",
    body: [
      "Een dakraam brengt daglicht op plekken waar dat eerst niet kwam. Het dak is opengemaakt, het raam is waterdicht geplaatst en rondom geïsoleerd.",
      "Aan de binnenzijde zijn de dagkanten strak afgetimmerd en afgewerkt, zodat het raam netjes in de ruimte valt en het licht optimaal benut wordt.",
    ],
    work: ["Dakraam plaatsen", "Isolatie rondom", "Dagkanten aftimmeren", "Nette binnenafwerking"],
  },
  {
    slug: "verbouwing-binnenwanden",
    title: "Verbouwing binnenwanden",
    category: "Timmerwerken",
    location: "Opmeer en omgeving",
    image: images.wandBinnen,
    summary:
      "Nieuwe binnenwanden met raamopening, beplating en voorbereiding voor elektra tijdens een verbouwing.",
    body: [
      "Bij deze verbouwing is de indeling aangepast met nieuwe binnenwanden. Het regelwerk is gesteld, de wanden zijn beplaat en er is een opening gemaakt voor een nieuw raam.",
      "In de wanden zijn de voorzieningen voor elektra alvast meegenomen, zodat de afwerking daarna zonder hakken en breken kon worden gedaan.",
    ],
    work: ["Regelwerk stellen", "Beplating", "Raamopening maken", "Voorbereiding elektra"],
  },
];

export const marqueeItems = [
  "Vakmanschap",
  "Opmeer, Noord-Holland",
  "Precisie in hout",
  "Timmerwerken",
  "Kozijnen",
  "Gevels",
  "Glas",
  "Veranda's",
  "Dakkapellen",
  "Onderhoud",
];

// Alles wat via het admin-paneel bewerkbaar is, als één document.
import { avVersie, avArtikelen } from "./voorwaarden";
import {
  garantieVersie, garantieTermijnen, garantieDekking, garantieDekkingToelichting,
  garantieUitsluitingen, garantieVoorwaarden, garantieProcedure,
} from "./garantie";

export const voorwaarden = { versie: avVersie, artikelen: avArtikelen };
export const garantie = {
  versie: garantieVersie,
  termijnen: garantieTermijnen,
  dekking: garantieDekking,
  dekkingToelichting: garantieDekkingToelichting,
  uitsluitingen: garantieUitsluitingen,
  voorwaarden: garantieVoorwaarden,
  procedure: garantieProcedure,
};

export const defaultContent = { site, pages, workArea, services, projects, voorwaarden, garantie };
